import { ITEM_STATUS_CODES } from "../utils/constants";
import { DisplayStatusIconProps } from "../types";
import { formatOperatorResponseLabel, OPERATOR_RESPONSE_VALUES } from "../utils/formPromptMapping";
import { IconAlertCircle, IconAlertTriangle, IconCheckCircle, IconClose } from "./ui";

const SIZE_CLASS = {
    small: "status-icon--small",
    normal: "status-icon--normal",
    medium: "status-icon--medium",
    big: "status-icon--big",
    large: "status-icon--large",
} as const;

export const DisplayStatusIcon = ({ children, size = "normal" }: DisplayStatusIconProps) => {
    const className = `status-icon ${SIZE_CLASS[size] ?? SIZE_CLASS.normal}`;

    switch (children) {
        case ITEM_STATUS_CODES.inop:
            return (
                <span className={`${className} status-icon--error`} role="img" aria-label="Inoperative">
                    <IconClose />
                </span>
            );
        case ITEM_STATUS_CODES.warn:
            return (
                <span className={`${className} status-icon--warning`} role="img" aria-label="Warning">
                    <IconAlertTriangle />
                </span>
            );
        case ITEM_STATUS_CODES.ok:
            return (
                <span className={`${className} status-icon--success`} role="img" aria-label="OK">
                    <IconCheckCircle />
                </span>
            );
        case ITEM_STATUS_CODES.na:
            return (
                <img
                    className={className}
                    src="/not-applicable-svgrepo-full-black.svg"
                    alt="Not applicable"
                />
            );
        case ITEM_STATUS_CODES.under_review:
        case ITEM_STATUS_CODES.status_unchanged:
            return (
                <span className={`${className} status-icon--info`} role="img" aria-label="In progress">
                    <IconAlertCircle />
                </span>
            );
        case OPERATOR_RESPONSE_VALUES.added:
        case OPERATOR_RESPONSE_VALUES.notAdded:
        case OPERATOR_RESPONSE_VALUES.cleaned:
        case OPERATOR_RESPONSE_VALUES.replaced:
            return <>{formatOperatorResponseLabel(String(children))}</>;
        default:
            return <>{children}</>;
    }
};
